/* Línea de tiempo de entrega (snippets/landing-delivery.liquid).
   Calcula las fechas con el día de hoy en Colombia, contando solo días hábiles. */
(() => {
  if (customElements.get('lp-delivery')) return;

  const MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

  function todayInColombia() {
    try {
      const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Bogota',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).formatToParts(new Date());
      const get = (type) => Number(parts.find((part) => part.type === type).value);
      return new Date(get('year'), get('month') - 1, get('day'));
    } catch (error) {
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    }
  }

  function addBusinessDays(start, days, countSaturday) {
    const date = new Date(start);
    let added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      const weekday = date.getDay();
      if (weekday === 0 || (weekday === 6 && !countSaturday)) continue;
      added++;
    }
    return date;
  }

  const format = (date) => `${date.getDate()} ${MONTHS[date.getMonth()]}`;

  function formatRange(from, to) {
    if (from.getTime() === to.getTime()) return format(from);
    if (from.getMonth() === to.getMonth()) return `${from.getDate()} – ${format(to)}`;
    return `${format(from)} – ${format(to)}`;
  }

  class LpDelivery extends HTMLElement {
    connectedCallback() {
      const number = (key) => parseInt(this.dataset[key], 10) || 0;
      const countSaturday = this.dataset.saturday === 'true';
      const today = todayInColombia();
      const between = (min, max) =>
        formatRange(addBusinessDays(today, number(min), countSaturday), addBusinessDays(today, number(max), countSaturday));

      const setText = (key, text) => {
        const element = this.querySelector(`[data-lp-date="${key}"]`);
        if (element) element.textContent = text;
      };

      setText('order', format(today));
      setText('dispatch', between('dispatchMin', 'dispatchMax'));
      setText('delivery', between('deliveryMin', 'deliveryMax'));
    }
  }

  customElements.define('lp-delivery', LpDelivery);
})();